import React              from 'react';
import { useTranslation } from 'react-i18next';
import { useSidebar }     from '../../providers/sidebar';
import sidebarConstants   from '../../providers/sidebar/sidebar.constants';
import classNames         from 'classnames';

import feedbackWebp from '../../assets/images/feedback.webp';
import feedbackPng  from '../../assets/images/feedback.png';

const ConsultationBlock = (props) => {
  const {
          isDark,
          maxWidth = '1000px',
        }               = props;
  const { t }           = useTranslation();
  const { showSidebar } = useSidebar();

  return (
    <section className={classNames('consultation_section', { 'background_color_black': isDark })}>
      <div className={'consultation_wrapper'} style={{ maxWidth: maxWidth }}>
        <div className={'description_wrapper'}>
          <h2>{t('client_get_consultation_title')}</h2>
          <p>{t('client_get_consultation_description')}</p>
          <button
            className={'btn'}
            onClick={() => showSidebar(sidebarConstants.CALL_ME_SIDEBAR)}
          >
            {t('client_get_contact')}
          </button>
        </div>
        <picture>
          <source srcSet={feedbackWebp} type={'image/webp'} />
          <source srcSet={feedbackPng} type={'image/png'} />
          <img
            className={'consultation_img'}
            src={feedbackPng}
            alt={'Feedback'}
          />
        </picture>
      </div>
    </section>
  );
};

export default ConsultationBlock;